import { Dialog, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  resourceName: string;
}

export function DeleteResourceDialog({ open, onClose, onConfirm, isPending, resourceName }: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete {resourceName}</DialogTitle>
      <p className="text-sm text-text-muted mb-6">
        Are you sure you want to delete this {resourceName.toLowerCase()}? This action cannot be undone.
      </p>
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={onClose} disabled={isPending}>Cancel</Button>
        <Button variant="destructive" onClick={onConfirm} disabled={isPending}>
          {isPending ? "Deleting..." : "Delete"}
        </Button>
      </div>
    </Dialog>
  );
}
